import TopJobFunctionsReducer from './TopJobFunctionsReducer';

export default from './TopJobFunctionsContainer';
export const TopJobFunctionsReducers = {
  TopJobFunctionsReducer,
};
